const fly_knowledgeBase: LegacyModule = {
	resultCount: 0,

	init: function () {
		this.cache();
		this.events();
	},

	cache: function () {
		this.$expandLinks = document.querySelectorAll('.js-expandArticleList');
		this.$searchForm = document.querySelector('.js-supportPageSearch');
		if (this.$searchForm) {
			this.$searchField = this.$searchForm.querySelector('input[name="query"]');
			this.$records = document.querySelectorAll('.knowledgeBaseContent .js-searchRecord');
			this.$summary = this.$searchForm.querySelector('.js-summary');
		}
	},

	events: function () {
		for (var i = this.$expandLinks.length - 1; i >= 0; i--) {
			this.$expandLinks[i].addEventListener('click', this.expandClick.bind(this));
		}
		if (this.$searchForm) {
			this.$searchForm.addEventListener('submit', this.searchSubmit.bind(this));
			this.$searchField.addEventListener('keyup', this.searchFieldChange.bind(this));
		}
	},

	expandClick: function (e) {
		var $link = e.currentTarget;
		var $list = $link.parentNode.querySelector('.js-collapsibleArticleList');
		var $inner = $list.querySelector('ul');
		var height = $inner.clientHeight;
		if ($list.classList.contains('expanded')) {
			$list.classList.remove('expanded');
			$list.removeAttribute('style');
			$link.innerHTML = 'More';
		} else {
			$list.classList.add('expanded');
			$list.style.maxHeight = height + 20 + 'px';
			$link.innerHTML = 'Less';
		}
	},

	searchSubmit: function (e) {
		e.preventDefault();
		//jump to first result?
	},

	searchFieldChange: function (_e) {
		this.performSearch();
	},

	performSearch: function () {
		var query = this.$searchField.value;
		query = query.toLowerCase().replace('ō', 'o');

		this.unfilterRecords();

		if (query.length > 1) {
			var terms = query.split(' ');
			//loop terms
			for (var i = terms.length - 1; i >= 0; i--) {
				var term = terms[i];
				if (term.length > 1) {
					this.filterRecords(term);
				}
			}
			this.updateSummary();
		} else {
			this.$summary.innerHTML = '';
		}
	},

	filterRecords: function (term) {
		for (var i = this.$records.length - 1; i >= 0; i--) {
			var $record = this.$records[i];
			var title = $record.querySelector('.js-searchTitle').textContent;
			var $description = $record.querySelector('.js-searchDescription');
			var description = $description ? $description.innerHTML : '';
			var tags = $record.getAttribute('data-tags') ? $record.getAttribute('data-tags') : '';

			title = title.toLowerCase().replace('ō', 'o');
			tags = tags.toLowerCase().replace('ō', 'o');
			description = description.toLowerCase().replace('ō', 'o');

			if (title.indexOf(term) > -1 || description.indexOf(term) > -1 || tags.indexOf(term) > -1) {
				this.resultCount++;
				$record.classList.add('js-relevant');
			}
		}
	},

	unfilterRecords: function () {
		this.resultCount = 0;
		for (var i = this.$records.length - 1; i >= 0; i--) {
			this.$records[i].classList.remove('js-relevant');
		}
	},

	updateSummary: function () {
		if (this.resultCount > 0) {
			var message = this.resultCount + ' result';
			if (this.resultCount > 1) message += 's';
			message += ' highlighted below';
		} else {
			var message = 'We couldn&rsquo;t find any results';
		}
		this.$summary.innerHTML = message;
	},
};
fly_knowledgeBase.init();
